// extracted by mini-css-extract-plugin
export var modal = "styles-module--modal--bc34d";
export var overlay = "styles-module--overlay--6a3cb";